import type {StaffIdCard} from '@/utils/IdCard.ts';
import type * as React from 'react';
import SvgText, {type TextBlock} from '../../../components/SvgText';
import Barcode from '../Barcode';

type Props = {
    idCard: StaffIdCard;
    width: string;
};

const StaffBack: React.FC<Props> = ({idCard, width = '100%'}: Props) => {
    const blocks: TextBlock[] = [];
    for (const directory of idCard.directory) {
        blocks.push({style: 'header', content: directory.header});
        blocks.push(directory.body);
        blocks.push('');
    }

    return (
        <svg viewBox='0 0 800 1200' width={width}>
            <title id={`staff-back-${idCard.id}`}>Staff Back for ID {idCard.id}</title>
            <defs>
                <clipPath id='card'>
                    <rect x={0} y={0} width={800} height={1200} rx={50} ry={50} />
                </clipPath>
            </defs>

            <SvgText
                blocks={blocks}
                x={40}
                y={60}
                fontSize={30}
                width={720}
                fill='black'
            />

            <Barcode idCard={idCard} transform='translate(400, 1000)' withoutRoot anchor='middle' />

            <rect
                x={1}
                y={1}
                width={800 - 2}
                height={1200 - 2}
                rx={50}
                ry={50}
                fill='transparent'
                stroke='#888'
                strokeWidth={2}
            />
        </svg>
    );
};

export default StaffBack;
